import * as React from 'react';

const SvgCloseMobile = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M17.221 2.37096L15.6293 0.779297L9.00013 7.4093L2.37096 0.779297L0.779297 2.37096L7.4093 9.00013L0.779297 15.6293L2.37096 17.221L9.00013 10.591L15.6293 17.221L17.221 15.6293L10.591 9.00013L17.221 2.37096Z'
      fill='#ACA6A6'
    />
  </svg>
);

export default SvgCloseMobile;
